import { render, staticRenderFns } from "./xncjdx.vue?vue&type=template&id=38ada966&scoped=true&"
import script from "./xncjdx.vue?vue&type=script&lang=js&"
export * from "./xncjdx.vue?vue&type=script&lang=js&"
import style0 from "./xncjdx.vue?vue&type=style&index=0&id=38ada966&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ada966",
  null
  
)

export default component.exports